import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import AsyncSelect, { Option, type AsyncSelectBaseProps } from "./AsyncSelect";
import { TaxStatusService } from "@/services/taxStatus";
import appConfiguration from "./cfg/AppCfg";

interface TaxStatusSelectProps extends AsyncSelectBaseProps {
  className?: string;
  defaultItem?: Partial<Option>;
}

export default forwardRef<HTMLButtonElement, TaxStatusSelectProps>(
  function TaxStatusSelect({ defaultItem, ...props }, ref) {
    const { t } = useTranslation();

    return (
      <AsyncSelect
        queryKey={["taxStatusList"]}
        queryFn={() =>
          TaxStatusService.getList({
            limit: appConfiguration.selectComponentsPaginationLimit,
          })
        }
        placeholder={t("taxStatusSelect.placeholder")}
        noResultsLabel={t("taxStatusSelect.noResults")}
        searchLabel={t("taxStatusSelect.search")}
        renderName={(option) => t(`taxStatus.${option.name}`)}
        enableFilter={false}
        clear={true}
        clearLabel={t("taxStatusSelect.clear")}
        {...props}
        defaultItem={defaultItem}
        ref={ref}
        className="w-full"
      />
    );
  },
);
